import React from 'react';
import { ProgressBar } from 'shared/ProgressBar';
import { Button } from 'shared/Button/NewButton';
import { CheckmarkCircleIcon } from 'shared/Icon/components/CheckmarkCircleIcon';
import {
  ContentWrapper,
  uploaderCancelButtonStyle,
  UploaderContainer,
  UploaderContentsContainer,
  UploaderStatusContainer,
  UploaderStatusHeading,
  UploaderStatusLabel,
} from '../styles';
import { IconWrapper } from './styles';

type UploadingStateProps = {
  percentageComplete?: number;
  onCancel: () => void;
  isProcessing?: boolean;
};

// TODO : Will be implemented by WHEEL-789
// https://anchorfm.atlassian.net/browse/WHEEL-789
const onClickCancelButton = (
  e: React.FormEvent,
  onCancelUpload: () => void
) => {
  e.preventDefault();
  onCancelUpload();
};

export const UploadingState = ({
  percentageComplete = 100,
  onCancel,
  isProcessing,
}: UploadingStateProps) => {
  const cancelButtonLabel = isProcessing ? 'Delete' : 'Cancel';
  return (
    <ContentWrapper>
      <UploaderContainer>
        <UploaderContentsContainer>
          <UploaderStatusHeading>
            {isProcessing
              ? 'Processing...'
              : percentageComplete === 100
              ? 'Uploaded!'
              : 'Uploading...'}
          </UploaderStatusHeading>
          <UploaderStatusLabel>
            {isProcessing
              ? 'An audio preview will be ready soon'
              : `${percentageComplete}%`}
          </UploaderStatusLabel>
        </UploaderContentsContainer>
        <UploaderStatusContainer>
          {!isProcessing && percentageComplete === 100 && (
            <IconWrapper>
              <CheckmarkCircleIcon />
            </IconWrapper>
          )}
        </UploaderStatusContainer>
      </UploaderContainer>
      <ProgressBar percentage={percentageComplete} height={4} />
    </ContentWrapper>
  );
};
